// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1LW3V","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__8-zuZ"};